import store from '@/store'
import { awaitGetter } from '@/utils/store/store-utils'
import { resolveBackTarget } from '@/utils/helpers'
import { DETAIL_WITH_COMMENTS_MAX_WIDTH } from '@/utils/constants'
import BookmarksView from '@/views/Bookmarks/All.vue'

export default [
  {
    path: '/bookmarks',
    components: {
      default: BookmarksView,
      sidebar: () => import('@/views/Bookmarks/components/BookmarksSidebar.vue'),
      appbar: () => import('@/views/Bookmarks/components/BookmarkAppBar.vue'),
    },
    beforeEnter: async (to, from, next) => {
      await awaitGetter(store, 'collectionItems/collectionId')
      next()
    },
    meta: {
      sidebarVisibility() {
        return true
      },
      appbarVisibility: true,
      requiresAuth: true,
      transition: 't-fade',
      layoutTransition: 't-expand',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/deleted',
    components: {
      default: () => import('@/views/Bookmarks/Deleted.vue'),
      appbar: () => import('@/views/Bookmarks/components/BookmarkAppBar.vue'),
    },
    beforeEnter: async (to, from, next) => {
      await awaitGetter(store, 'collectionItems/collectionId')
      next()
    },
    meta: {
      appbarVisibility: true,
      requiresAuth: true,
      transition: 't-fade',
      layoutTransition: 't-expand',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/add',
    component: () => import('@/views/Bookmarks/AddBookmark.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/:bookmarkId/edit',
    component: () => import('@/views/Bookmarks/Edit.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      layoutProps: {
        backButton: {
          to: from => `/bookmarks/${from.params.bookmarkId}`,
        },
      },
    },
  },
  {
    path: '/bookmarks/bulk/add-tags',
    component: () => import('@/views/Bookmarks/BulkEditTags.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/bulk/remove-tags',
    component: () => import('@/views/Bookmarks/BulkRemoveTags.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/:bookmarkId/tags',
    component: () => import('@/views/Bookmarks/EditTags.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      layoutProps: {
        backButton: {
          to: route => resolveBackTarget(
            route,
            `/bookmarks/${route.params.bookmarkId}`,
          ),
        },
      },
    },
  },
  {
    path: '/bookmarks/bulk/add-collections',
    component: () => import('@/views/Bookmarks/BulkAddToCollections.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/:id/add-collections',
    component: () => import('@/views/CollectionItems/AddToCollections.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/:bookmarkId/pin',
    component: () => import('@/views/CollectionItems/EditPinPosition.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/:bookmarkId',
    component: () => import('@/views/Bookmarks/BookmarkDetail.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus-detail',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      layoutProps: {
        maxWidthDesktop: DETAIL_WITH_COMMENTS_MAX_WIDTH,
        backButton: {
          // ?from= honored so detour flows (e.g. the intro-item picker) get
          // the user back; without it behaves as before.
          to: route => resolveBackTarget(route, '/bookmarks'),
        },
      },
    },
  },
  {
    path: '/bookmarks/:id/notes',
    redirect: to => `/bookmarks/${to.params.id}`,
  },
]
